import {
  AnyHash,
  FieldConfig,
  FieldDataTypes,
  nString,
} from '@hidat/huijs-common';
import { ZonedDateTime } from '@js-joda/core';
import { MediaContentTypes } from './splixer-types';
import { SplixerResourceInterface } from './splixer-resource.interface';
import { ResourceConfig, SearchFilterConfig } from '@hidat/huijs-resource';
import { SortOrder } from '@hidat/huijs-api';
import { SegmentConfig } from './segment.interface';
import { HashViews } from './hash-views';

export const MediaTitleConfig = new ResourceConfig('MediaTitle', 'media_titles', false)
  .addFields(
    [
      new FieldConfig('mediaItemId', FieldDataTypes.INTEGER, false),
      new FieldConfig('seqNum', FieldDataTypes.INTEGER),
      new FieldConfig('audioOffset', FieldDataTypes.INTEGER),
      new FieldConfig('duration', FieldDataTypes.INTEGER),
      new FieldConfig('broadcastedAt', FieldDataTypes.DATEZONED),
      new FieldConfig('contentType'),
      new FieldConfig('comment'),
      new FieldConfig('content', FieldDataTypes.HASH),
      new FieldConfig('traits', FieldDataTypes.HASH).setEditable(false),
    ],
    true,
    HashViews.player,
  )
  .addFields([
    new FieldConfig('titleId', FieldDataTypes.INTEGER, false),
    new FieldConfig('rawPlayId', FieldDataTypes.INTEGER, false),
  ])
  .setSorts({
    seqnum: 'seqNum',
    broadcastedat: {
      dbName: 'broadcastedAt',
      defaultOrder: SortOrder.DESC,
      secondarySort: {
        dbName: 'seqNum',
        order: SortOrder.ASC,
      },
    },
  })
  .setDefaultSort('broadcastedat');

export const MediaTitleIncludes = {
  mediaItem: 'mediaItem',
};

export const MediaTitleFilterConfig = new SearchFilterConfig(SegmentConfig, {
  only: ['mediaItemId', 'titleId'],
}).addRangeField('broadcastedAt', FieldDataTypes.DATE);

/**
 * Standard Media Content Item
 * As created by the Rails API, so we are stuck with it for now...
 A station/channel can add more to this if needed.
 */
export interface MediaContentInterface {
  name?: nString;
  performer_name?: nString;
  release_name?: nString;
  label_name?: nString;
  release_date?: nString;
  cover_art_url?: nString;
  default?: boolean; // Is this a system generated 'default' content item  (move to traits???)

  // Classical fields, thanks Spinitron
  work?: string;
  conductor?: string;
  performers?: string;
  ensemble?: string;

  isrc?: string;
  name_key?: nString;
  performer_key?: nString;
  release_key?: nString;
  label_key?: nString;
  comment?: nString;
  broadcasted_at?: nString;
  content_type?: nString;

  buy?: AnyHash;
}

export class MediaTraitsInterface {
  isLocal?: boolean;
  isRequest?: boolean;
  isLivePerformance?: boolean;
  isClassical?: boolean;
}

export interface MediaTitleInterface extends SplixerResourceInterface<number> {
  rawPlayId: number | undefined;
  mediaItemId: number | undefined;
  titleId: number | undefined;
  seqNum: number | undefined;
  audioOffset: number | undefined;
  broadcastedAt: ZonedDateTime | undefined;
  duration: number | undefined;
  contentType: MediaContentTypes | undefined;

  content: MediaContentInterface | undefined;
  traits: MediaTraitsInterface | undefined;
  comment: nString;
}
